module.exports = __webpack_public_path__ + "f72153314920f244e060b6c6004c8db3.svg";